/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
// import 'vuetify/styles';
import '@/settings.scss'

// Composables
import { createApp } from 'vue'
import { createVuetify } from 'vuetify'
import { aliases, fa } from 'vuetify/iconsets/fa-svg'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const app = createApp()

app.component('font-awesome-icon', FontAwesomeIcon) // Register component globally
library.add(fas) // Include needed solid icons
library.add(far) // Include needed regular icons

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
const vuetifyInstance = createVuetify({
    icons: {
        defaultSet: 'fa',
        aliases,
        sets: {
            fa
        }
    },
    components: {
        ...components
    },
    directives
})

// ✅ Export as a plugin-style object so it works with `.use(vuetify)`
export default {
    install(app) {
        app.use(vuetifyInstance)
        app.component('font-awesome-icon', FontAwesomeIcon)
    },
}
